import React from "react";
import { ITilesData } from "../../exports/interfaces";
import useMobile from "../../hooks/useMobile";
import DynamicToolTip from "../DynamicToolTip";
import { Fade } from "react-awesome-reveal";

const Tiles = (props: { tilesData: ITilesData[] }) => {
  const mobile = useMobile();
  return (
    <section className="feature-two">
      <div className="container">
        <div className="feature-two__inner">
          <div className="row" style={{ justifyContent: "space-evenly" }}>
            <div className="col-xl-6 col-lg-6">
              <div
                className="feature-two__single wow fadeInUp"
                data-wow-delay="100ms"
              >
                <Fade cascade damping={0.2} triggerOnce={true}>
                  <div className="feature-two__img">
                    <img
                      src={`${process.env.REACT_APP_strapiUrl}${props?.tilesData[0]?.attributes?.First_Image?.data?.attributes?.url}`}
                      alt="tiles-image1"
                      style={{
                        objectFit: "cover",
                      }}
                    />
                    <div className="feature-two__content">
                      {mobile && (
                        <span className="icon-solidarity custom-tiles-icon"></span>
                      )}{" "}
                      <h3 className="feature-two__title">
                        {!mobile && (
                          <span className="icon-solidarity custom-tiles-icon"></span>
                        )}{" "}
                        {props?.tilesData[0]?.attributes?.First_Title}
                      </h3>
                      <DynamicToolTip title="Know More">
                        <a href="/about" className="feature-two__arrow">
                          <span className="icon-right-arrow"></span>
                        </a>
                      </DynamicToolTip>
                    </div>
                  </div>
                </Fade>
              </div>
            </div>
            <div className="col-xl-6 col-lg-6">
              <div
                className="feature-two__single wow fadeInUp"
                data-wow-delay="200ms"
              >
                <Fade cascade damping={0.2} delay={200} triggerOnce={true}>
                  <div className="feature-two__img feature-two__img-2">
                    <img
                      src={`${process.env.REACT_APP_strapiUrl}${props?.tilesData[0]?.attributes?.Second_Image?.data?.attributes?.url}`}
                      alt="tiles-image2"
                      style={{
                        objectFit: "cover",
                      }}
                    />
                    <div className="feature-two__content">
                      {mobile && (
                        <span className="icon-sponsor custom-tiles-icon"></span>
                      )}{" "}
                      <h3 className="feature-two__title">
                        {!mobile && (
                          <span className="icon-sponsor custom-tiles-icon"></span>
                        )}{" "}
                        {props?.tilesData[0]?.attributes?.Second_Title}
                      </h3>
                      <DynamicToolTip title="Know More">
                        <a href="/about" className="feature-two__arrow">
                          <span className="icon-right-arrow"></span>
                        </a>
                      </DynamicToolTip>
                    </div>
                  </div>
                </Fade>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Tiles;
